import {
  LOGIN_ROUTE,
  SIGNUP_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  VERIFY_EMAIL_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  SUBSCRIPTION_WALL_ROUTE,
  SUBSCRIPTION_CANCELLED_ROUTE,
} from "@/router/routes";

export const AUTH_ONLY_ROUTES: Set<string> = new Set([
  LOGIN_ROUTE,
  SIGNUP_ROUTE,
  FORGOT_PASSWORD_ROUTE,
  RESET_PASSWORD_ROUTE,
  VERIFY_EMAIL_ROUTE,
  EMAIL_VERIFICATION_WALL_ROUTE,
  SUBSCRIPTION_WALL_ROUTE,
  SUBSCRIPTION_CANCELLED_ROUTE,
]);

export const AUTH_ONLY_PATH_PREFIXES: readonly string[] = [
  "/subscription-success",
  "/payment-setup-success",
];

export function isAuthOnlyRoute(name?: string | null, path?: string | null): boolean {
  if (name && AUTH_ONLY_ROUTES.has(name)) return true;
  if (path && AUTH_ONLY_PATH_PREFIXES.some((p) => path.startsWith(p))) return true;
  return false;
}
